<template>
    <div v-show="!$route.meta.noTopHeader">
        <div class="header-fix">
            <base-logo></base-logo>
        </div>
        <div
            v-if="$route.meta.showSideBar"
            class="responsive-sidebar-menu"
            @click="$emit('sidemenu')"
        >
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div
            v-if="menuListing && menuListing.length > 0"
            class="responsive-header-menu"
            @click="mainMain ^= true"
        >
            <img src="@/assets/images/sub-menu.svg" />
        </div>

        <header
            class="header"
            :class="
                (stepStyle == true ? 'step-menu-header' : '',
                mainMain == true ? 'show-menu' : '')
            "
        >
            <div
                class="header-menu navigation"
                :class="stepStyle == true ? 'step-menu' : ''"
            >
                <span class="close-side-bar" @click="mainMain = false"
                    ><i class="icon-delete"></i
                ></span>
                <div
                    v-if="$route.meta.showSideBar == false"
                    class="logo-container"
                >
                    <base-logo class="main-logo desktop-logo" style="margin-top:3px" ></base-logo>
                </div>
                <ul class="menu-list">
                    <li
                        v-for="(list, index) in allowedMenuListing"
                        :key="index"
                        :class="[
                            $route.meta.sessionStep &&
                            $route.meta.sessionStep == list.sessionStep
                                ? 'router-link-exact-active'
                                : '',
                            $route.meta.sessionStep &&
                            parseInt($route.meta.sessionStep) >= parseInt(list.sessionStep)
                                ? 'router-link-active'
                                : '',
                        ]"
                        @click="mainMain = false"
                    >
                        <div class="route">
                          <router-link
                            :to="{ name: list.name }"
                            :class="[
                                $route.name.toString() === list.name.toString()
                                    ? 'router-link-active router-link-exact-active'
                                    : '',
                                $route.meta.innerTabName ==
                                list.menuLabel.toString()
                                    ? 'router-link-active router-link-exact-active'
                                    : '',
                            ]"
                          >
                            <span v-if="stepStyle" class="point">
                                <i class="icon-check-circle"></i>
                            </span>
                            <span>{{ list.menuLabel }}</span>

                            <span v-if="list.dataLength && list.dataLength<100" class="icn-warning" >{{list.dataLength}}</span>
                            <span v-if="list.dataLength && list.dataLength>99" class="icn-warning">99+</span>
                          </router-link>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-if="$route.meta.showSideBar == true" class="profile-block" style="width:50px !important">
            <notification-popover v-if="hasScopes('notification-bar')"></notification-popover>
            </div>
            <div v-if="$route.meta.showSideBar == true" class="profile-block">
                <login-detail> </login-detail>
                <update-profile-popup></update-profile-popup>
                <change-password-popup></change-password-popup>
            </div>

        </header>
        <div
            v-if="
                subscription == 'trial' &&
                this.$route.meta.publicRegistration == false
            "
        >
            <b-alert show dismissible variant="success">
                <h4 class="alert-heading">Thank you for signing up!</h4>
                <p>
                    You have used {{ counter }} Onboardings out of {{ tier }}.
                    To continue, please upgrade your package.
                </p>
                <!--                <hr />-->
                <!--                <p class="mb-0">-->
                <!--                    Whenever you need to, be sure to use margin utilities to-->
                <!--                    keep things nice and tidy.-->
                <!--                </p>-->
                <b-button @click="upgrade()">Upgrade</b-button>
            </b-alert>
            
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import loginDetail from '@/components/LoginDetail.vue'
import updateProfilePopup from '@/components/popups/UpdateProfilePopup.vue'
import changePasswordPopup from '@/components/popups/ChangePasswordPopup.vue'
import NotificationPopover from '@/components/NotificationPopover.vue'

import { directive as onClickOutside } from 'vue-on-click-outside'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import resource from '@/api/resource'

//const roleApi = new resource('access-control/roles')
const dataSegmentApi = new resource('users/data-segment')

export default {
    components: {
        loginDetail,
        changePasswordPopup,
        updateProfilePopup,
        NotificationPopover
    },
    directives: {
        onClickOutside: onClickOutside,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        menuListing: {
            type: Array,
            default: null,
        },
        stepStyle: {
            type: Boolean,
            default: false,
        },
        params: {
            type: Object,
            default: undefined,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            mainMain: false,
            image: 'profile-pic.png',
            dataSegmentList: [],
            counter: 0,
            tier: '',
            subscription: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['user', 'scopes', 'dataSegmentId','hasScopes']),

        allowedMenuListing() {
            if (this.menuListing) {
                return this.menuListing.filter((item) => {
                    return this.checkPermission(item.permission)
                })
            }
        },
    }, // End of Component > methods

    watch : {
      dataSegmentId(value) {
        if(value) {
          this.getDataSegmentDetails()
        }
      }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {

    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        checkPermission(scopes) {
            if (this.$route.meta.requiresAuth) {
                return !!_.intersection(scopes, this.scopes).length
            }
            return true
        },

      upgrade() {
        this.$router.push('/billing')
      },
      async getDataSegmentDetails() {

        let dataSegment = await dataSegmentApi.get(this.dataSegmentId)
        this.dataSegmentList.push(dataSegment.data.data)

        this.tier = dataSegment.data.data.tier
        this.subscription = dataSegment.data.data.subscription
        if(this.subscription == 'unpaid') {
          this.counter = 0
        } else {
          this.counter = dataSegment.data.data.counter

        }

        this.$store.commit('setDataSegmentList',this.dataSegmentList)
      },

    }, // End of Component > mounted
} // End of export default
</script>
<style>
    /* Keep the primary nav on a single row on desktop widths; the existing
       hamburger/off-canvas menu (@include tabletL and below, see _header.scss)
       already handles narrower screens and is left untouched. */
    @media (min-width: 1141px) {
        .header-menu.navigation .menu-list {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            overflow-x: auto;
            overflow-y: hidden;
            -ms-overflow-style: none;
            scrollbar-width: none;
        }
        .header-menu.navigation .menu-list::-webkit-scrollbar {
            display: none;
        }
        .header-menu.navigation .menu-list li {
            flex: 0 0 auto;
        }
    }
    /* .header{
     height: max-content;
    } */
    .icn-warning
    {
        color: white !important;
        font-size: 15px;
        text-align: center;
        min-width: 17px;
        height: 17px;
        border-radius: 14px;
        position: absolute;
        top: 17px;
        right: -12px;
        padding: 1px 4px;
        font-weight: 500;
        align-items: center;
        justify-content: center;
        background-color: #f64747 
    }
</style>
